import React, { useEffect, useState } from 'react';
import DropDownButtonGlobal, { KeyValueFilterObject } from 'modules/Common/Components/DropDownButtonGlobal';
import { DropDownIconsType } from 'modules/Common/Components/ToggleFilterButtonGlobal';
import {
  globalContactsOrganizationsResetSearchAction,
  globalContactsSelectOrganizationAction,
  listContactsOrganizationsResetSearchAction,
  listContactsSelectOrganizationAction,
  loadGlobalOrganizationsAction,
  loadListOrganizationsAction,
} from 'modules/Audience/Actions/contactsFiltersActions';
import { getQueryListId } from 'utils';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

interface IStatusFilters {
  CompanyActiveFilterData: DropDownIconsType;
  CompanyFilterData: DropDownIconsType;
  CompanySelectedFilterData: DropDownIconsType;
  listDetailsSearchTerm: string;
}

const OrganizationsFilters: React.FC<IStatusFilters> = ({
  CompanyActiveFilterData,
  CompanyFilterData,
  CompanySelectedFilterData,
  listDetailsSearchTerm,
}) => {
  const globalContactsOrganizationsLoading = useSelector((state: RootState) => state.contactsFilters.globalContactsFilters.organizations.loading);
  const globalContactsOrganizations = useSelector((state: RootState) => state.contactsFilters.globalContactsFilters.organizations.data);
  const globalContactsOrganizationsSelected = useSelector(
    (state: RootState) => state.contactsFilters.globalContactsFilters.selectedFilters.organization,
  );
  const globalSearchedOrganizations = useSelector((state: RootState) => state.contactsFilters.globalContactsFilters.organizations.searchedData);
  const globalSearchedOrganizationsLoading = useSelector(
    (state: RootState) => state.contactsFilters.globalContactsFilters.organizations.searchedLoading,
  );
  const globalOrganizationSearchTerm = useSelector((state: RootState) => state.contactsFilters.globalContactsFilters.organizations.searchTerm);
  const globalAddToListMode = useSelector((state: RootState) => state.globalContacts.addToListGlobalMode);

  const listContactsOrganizationsLoading = useSelector((state: RootState) => state.contactsFilters.listContactsFilters.organizations.loading);
  const listContactsOrganizations = useSelector((state: RootState) => state.contactsFilters.listContactsFilters.organizations.data);
  const listContactsOrganizationsSelected = useSelector(
    (state: RootState) => state.contactsFilters.listContactsFilters.selectedFilters.organization,
  );
  const listSearchedOrganizations = useSelector((state: RootState) => state.contactsFilters.listContactsFilters.organizations.searchedData);
  const listSearchedOrganizationsLoading = useSelector(
    (state: RootState) => state.contactsFilters.listContactsFilters.organizations.searchedLoading,
  );
  const listOrganizationSearchTerm = useSelector((state: RootState) => state.contactsFilters.listContactsFilters.organizations.searchTerm);

  const isListView = globalAddToListMode ? null : getQueryListId();
  const [selectedFilters, setSelectedFilters] = useState<string[]>(isListView
    ? listContactsOrganizationsSelected : globalContactsOrganizationsSelected);
  const [isSearched, setIsSearched] = useState(false);

  const handleClickCheckBox = (value: string, add: boolean) => {
    let newSelectedFilters: string[] = [];
    if (add) {
      newSelectedFilters = [...selectedFilters, value];
    } else {
      newSelectedFilters = selectedFilters.filter((item) => item !== value);
    }
    setSelectedFilters(newSelectedFilters);
    if (isListView) {
      if (listDetailsSearchTerm) {
        // If user is in Add To List view.
        listContactsSelectOrganizationAction(newSelectedFilters, true, false);
        globalContactsSelectOrganizationAction(newSelectedFilters, true, false);
      } else {
        listContactsSelectOrganizationAction(newSelectedFilters, true, false);
      }
    } else {
      globalContactsSelectOrganizationAction(newSelectedFilters, true, false);
    }
  };

  const handleSearch = (value: string) => {
    if (isListView) {
      loadListOrganizationsAction(isListView?.toString(), value);
    } else {
      loadGlobalOrganizationsAction(value);
    }
    setIsSearched(true);
  };

  const handleClearSearch = () => {
    if (isListView) {
      listContactsOrganizationsResetSearchAction();
      if (listContactsOrganizations.length === 0) {
        loadListOrganizationsAction(isListView?.toString());
      }
    } else {
      globalContactsOrganizationsResetSearchAction();
      if (globalContactsOrganizations.length === 0) {
        loadGlobalOrganizationsAction();
      }
    }
    setIsSearched(false);
  };

  const globalOrganizationsData = globalOrganizationSearchTerm !== '' || isSearched ? globalSearchedOrganizations : globalContactsOrganizations;
  const listOrganizationsData = listOrganizationSearchTerm !== '' || isSearched ? listSearchedOrganizations : listContactsOrganizations;

  const globalOrganizationLoading = globalOrganizationSearchTerm !== '' ? globalSearchedOrganizationsLoading : globalContactsOrganizationsLoading;
  const listOrganizationLoading = listOrganizationSearchTerm !== '' ? listSearchedOrganizationsLoading : listContactsOrganizationsLoading;

  const newData = [...(isListView ? listOrganizationsData : globalOrganizationsData)]
    .map((item) => ({
      value: item,
      name: item,
    }));

  useEffect(() => {
    setSelectedFilters(isListView
      ? listContactsOrganizationsSelected : globalContactsOrganizationsSelected);
  }, [globalContactsOrganizationsSelected, listContactsOrganizationsSelected]);

  return (
    <DropDownButtonGlobal
      title="Company"
      loading={isListView ? listOrganizationLoading : globalOrganizationLoading}
      // disable-next-line @typescript-eslint/no-unsafe-assignment
      btnData={CompanyFilterData}
      data={newData as KeyValueFilterObject[]}
      activeBtnData={CompanyActiveFilterData}
      selectedFiltersBtnData={CompanySelectedFilterData}
      selectedFilters={selectedFilters}
      onClickCheckBox={handleClickCheckBox}
      handleSearchProps={handleSearch}
      clearSearchProps={handleClearSearch}
    />
  );
};

export default OrganizationsFilters;
